export const decodeHtmlSymbols = (stringWithHtml: string): string => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = stringWithHtml;
  return tempElement.textContent || '';
};
